import styled from "@emotion/styled";
import { Slider } from "@mui/material";

interface ProgressSliderProps
{
    railPct: number;
    trackPct: number;
    hasError: boolean;
    themecolor: string;
}

export const doNotForwardIsMobile = ( prop: string ) => prop !== "isMobile";
export const ProgressSlider = styled( Slider, {
    shouldForwardProp: ( prop ) => doNotForwardIsMobile( prop ) &&
        prop !== "themeMain" &&
        prop !== "railPct" &&
        prop !== "trackPct" &&
        prop !== "hasError"
} )<ProgressSliderProps>( ( { themecolor, railPct, trackPct, hasError } ) => ( {
    ".MuiSlider-rail": {
        background: `linear-gradient(90deg, ${themecolor} ${railPct}%, ${hasError ? "#FF0000" : "#222222"} ${railPct}%)`,
    },
    ".MuiSlider-track": {
        background: `linear-gradient(90deg, ${themecolor} ${trackPct}%, ${hasError ? "#FF0000" : "#888888"} ${trackPct}%)`,
        borderColor:
            trackPct < 100
                ? hasError
                    ? "#FF0000"
                    : "#888888"
                : themecolor,
    },
    ".MuiSlider-thumb": {
        background:
            trackPct < 100
                ? hasError
                    ? "#FF0000"
                    : "#888888"
                : themecolor,
    },
} ) );
